import { createReducer, on } from "@ngrx/store";
import { ConfirmationPageActions, WireActions } from "../actions";

export const saveAsTemplateModalKey = 'saveAsTemplateModal';

export interface State {
    templateNickname: string;
}

export const initialSaveAsTemplateModalState: State = {
    templateNickname: ''
}

export const reducer = createReducer(
    initialSaveAsTemplateModalState,
    on(ConfirmationPageActions.updateTemplateNickname, (state, action) => {
      return {
        ...state,
        templateNickname: action.nickname
      }
    }),
    on(WireActions.updateWiresTemplateNickname, (state, action) => {
      return {
        ...state,
        templateNickname: action.nickname
      }
    })
)
